import { BrowserRouter as Router } from 'react-router-dom';
import { Layout } from 'antd';

import SiderApp from '../../containers/Sider';
import ContentApp from '../../containers/Content';

import './style.scss';
import { CompatRouter } from 'react-router-dom-v5-compat';

const PrivateLayout = () => {
  return (
    <Layout className="private-layout">
      <Router>
        <CompatRouter>
          <Layout className="private-secondary-layout">
            <SiderApp />
            <ContentApp />
          </Layout>
        </CompatRouter>
      </Router>
    </Layout>
  );
};

export default PrivateLayout;
